






























import { Button } from 'element-ui'
import { Printd } from 'printd'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'

import Passenger from '@/models/passenger'
import Payment from '@/models/payment'

import { longDateFormat } from '@/globalFilters'

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class SuccessPaymentTab extends Vue {
  @Prop() payment!: Payment
  @Prop({ default: true }) printable!: boolean
  @Ref() readonly printablePaymentRef!: HTMLElement

  dateFormat = longDateFormat

  printPayment() {
    const printer: Printd = new Printd()
    printer.print(this.printablePaymentRef, [
      // paymentSegmentListStyles.toString(),
      this.printStyles,
    ])
  }

  get printStyles() {
    return `
      .payment__total {
        margin: 15px 30px;
        font-size: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-basis: 100%;
        height: 100%;
        text-align: left;
      }
    `
  }
}
